// components/industry-templates/NetworkingEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Users, MessageCircle, Briefcase, Coffee } from 'lucide-react';

export const NetworkingEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      <Card className="border-0 bg-gradient-to-br from-blue-500/20 to-cyan-500/20 backdrop-blur">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2 text-2xl">
            <Users className="w-8 h-8" style={{ color: theme.primary }} />
            Networking Opportunities
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 gap-4">
            {industryData?.expected_attendees && (
              <div className="p-6 bg-white/10 rounded-xl text-center">
                <p className="text-4xl font-bold mb-2" style={{ color: theme.primary }}>
                  {industryData.expected_attendees}+
                </p>
                <p className="text-white">Professionals</p>
              </div>
            )}
            {industryData?.industries_represented && (
              <div className="p-6 bg-white/10 rounded-xl text-center">
                <p className="text-4xl font-bold mb-2" style={{ color: theme.primary }}>
                  {industryData.industries_represented}
                </p>
                <p className="text-white">Industries</p>
              </div>
            )}
          </div>
        </CardContent>
      </Card>

      {industryData?.networking_formats && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <MessageCircle className="w-6 h-6" style={{ color: theme.primary }} />
              Networking Formats
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              {industryData.networking_formats.map((format: any, idx: number) => (
                <div key={idx} className="p-4 bg-white/5 rounded-lg border-l-4" style={{ borderColor: theme.primary }}>
                  <h4 className="font-bold text-white mb-1">{format.type}</h4>
                  <p className="text-sm text-slate-400">{format.description}</p>
                  <Badge className="mt-2" style={{ backgroundColor: theme.primary }}>
                    {format.duration}
                  </Badge>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {industryData?.refreshments && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Coffee className="w-6 h-6" style={{ color: theme.primary }} />
              Refreshments & Catering
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="bg-white/5 rounded-lg p-4">
              <p className="text-white">
                {industryData.refreshments ? '✓ Complimentary food & beverages' : '✗ No refreshments'}
              </p>
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
